<div class="container-fluid">
  <div class="row">
    <div class="col-6">
      @if (!bedroom) {
        <h2 mat-dialog-title>Add Bedroom</h2>
      }
    </div>
    <div class="col-6 text-right">
      @if (!bedroom) {
        <button mat-icon-button [mat-dialog-close]="true">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-dialog-content>
        <mat-tab-group>
          <mat-tab label="Details">
            <div [formGroup]="form1">
              <div class="row">
                <div class="col-12">
                  @if (formAlert) {
                    <div class="block">
                      <div style="flex: 0 0 calc(100% - 10px); text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                        <p><b>{{formAlert}}</b></p>
                      </div>
                    </div>
                  }
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Name</mat-label>
                    <mat-select [(value)]="form1.value.name" formControlName="name">
                      @for (stat of bedroomNames; track stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.name; track validation) {
                      <mat-error>
                        @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Type</mat-label>
                    <mat-select [(value)]="form1.value.bedroomType" formControlName="bedroomType">
                      @for (stat of bedroomTypes; track stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.bedroomType; track validation) {
                      <mat-error>
                        @if (form1.get('bedroomType').hasError(validation.type) && (form1.get('bedroomType').dirty || form1.get('bedroomType').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Sleeps Max</mat-label>
                    <input matInput formControlName="sleepsMax" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sleepsMax; track validation) {
                      <mat-error>
                        @if (form1.get('sleepsMax').hasError(validation.type) && (form1.get('sleepsMax').dirty || form1.get('sleepsMax').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Sleeps Max In Beds</mat-label>
                    <input matInput formControlName="sleepsMaxInBeds" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.sleepsMaxInBeds; track validation) {
                      <mat-error>
                        @if (form1.get('sleepsMaxInBeds').hasError(validation.type) && (form1.get('sleepsMaxInBeds').dirty || form1.get('sleepsMaxInBeds').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Access</mat-label>
                    <mat-select [(value)]="form1.value.accessVia" formControlName="accessVia">
                      @for (stat of accessVias; track stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.accessVia; track validation) {
                      <mat-error>
                        @if (form1.get('accessVia').hasError(validation.type) && (form1.get('accessVia').dirty || form1.get('accessVia').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Attached Bathroom</mat-label>
                    <mat-select [(value)]="form1.value.bathroomAccessType" formControlName="bathroomAccessType">
                      @for (stat of bathroomAccessTypes; track stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.bathroomAccessType; track validation) {
                      <mat-error>
                        @if (form1.get('bathroomAccessType').hasError(validation.type) && (form1.get('bathroomAccessType').dirty || form1.get('bathroomAccessType').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>View</mat-label>
                    <mat-select [(value)]="form1.value.viewType" formControlName="viewType">
                      @for (stat of viewTypes; track stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.viewType; track validation) {
                      <mat-error>
                        @if (form1.get('view.viewType').hasError(validation.type) && (form1.get('view.viewType').dirty || form1.get('view.viewType').touched)) {
                          <mat-error class="error-message">
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="block">
                    <mat-label>Air Conditioning</mat-label>
                    <mat-select [(value)]="form1.value.airConditioningType" formControlName="airConditioningType">
                      @for (stat of airConditioningTypes; track stat) {
                        <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.airConditioningType; track validation) {
                      <mat-error>
                        @if (form1.get('view.airConditioningType').hasError(validation.type) && (form1.get('view.airConditioningType').dirty || form1.get('view.airConditioningType').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12">
                  <mat-form-field style="flex: 0 0 calc(100% - 10px)">
                    <mat-label>General Description</mat-label>
                    <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="500"
                    matTooltip="Enter description, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.description; track validation) {
                      <mat-error>
                        @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12">
                  <mat-form-field style="flex: 0 0 calc(100% - 10px)">
                    <mat-label>Amenities Desc</mat-label>
                    <textarea matInput formControlName="consumablesDesc" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="500"
                    matTooltip="Enter consumablesDesc, paragrphs are ok."></textarea>
                    @for (validation of validationMessages.consumablesDesc; track validation) {
                      <mat-error>
                        @if (form1.get('consumablesDesc').hasError(validation.type) && (form1.get('consumablesDesc').dirty || form1.get('consumablesDesc').touched)) {
                          <mat-error class="error-message">
                            {{validation.message}}
                          </mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12">
                  <div style="flex: 0 0 calc(100% - 10px)">
                    @if (bedroomId) {
                      <button style="float:left;" mat-raised-button color="error" (click)="formDelete()" [disabled]="!form1.valid">Delete Bedroom</button>
                    }
                    @if (bedroomId) {
                      <button style="float:right;" mat-raised-button color="primary" (click)="formUpdate()" [disabled]="!form1.valid">Update Bedroom</button>
                    }
                    @if (!bedroomId) {
                      <button style="float:right;" mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Add Bedroom</button>
                    }
                    @if (!bedroomId) {
                      <button style="float:left;" mat-raised-button [mat-dialog-close]="true">Done</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>

          @if (bedroom) {
            <div>
              <div class="row">
                <div class="col-12">
                  <mat-tab label="Beds">
                    <app-bed class="flex-1" [bedroomId]="bedroomId" [beds]="bedroom.beds"></app-bed>
                  </mat-tab>
                </div>
                <div class="col-12">
                  <mat-tab label="Features">
                    <ng-template matTabContent>
                      <div class="row">
                        <div class="col-12">
                          <app-feature-list class="w-100" [featuresList]="featuresList" title="Bedroom Type" [shortTermRentalId]="shortTermRentalId" featureType="bedroomLeadFeature" describesType="{{bedroom.name}}">
                          </app-feature-list>
                        </div>
                        <br><br>
                        <div class="col-12">
                          <app-feature-list class="w-100" [featuresList]="featuresList" title="Bedroom Type" [shortTermRentalId]="shortTermRentalId" featureType="bedroomType" describesType="{{bedroom.name}}">
                          </app-feature-list>
                        </div>
                        <br><br>
                        <!-- <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Bed Size" [shortTermRentalId]="shortTermRentalId" featureType="bedSize" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div> -->
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Linens" [shortTermRentalId]="shortTermRentalId" featureType="bedroomLinens" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Features" [shortTermRentalId]="shortTermRentalId" featureType="bedroomFeature" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Furniture" [shortTermRentalId]="shortTermRentalId" featureType="furniture" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Finishes" [shortTermRentalId]="shortTermRentalId" featureType="finish" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Special Access" [shortTermRentalId]="shortTermRentalId" featureType="bedroomAccess" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <h3 class="property-subsection-title">Views</h3>
                      </div>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="View" [shortTermRentalId]="shortTermRentalId" featureType="view" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <h3 class="property-subsection-title">Electronics</h3>
                      </div>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Channels" [shortTermRentalId]="shortTermRentalId" featureType="tvChannels" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Players" [shortTermRentalId]="shortTermRentalId" featureType="tvPlayers" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Service" [shortTermRentalId]="shortTermRentalId" featureType="tvService" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="TV Type" [shortTermRentalId]="shortTermRentalId" featureType="tvType" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Phone" [shortTermRentalId]="shortTermRentalId" featureType="phone" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Music" [shortTermRentalId]="shortTermRentalId" featureType="music" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Internet" [shortTermRentalId]="shortTermRentalId" featureType="internet" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                      <br><br>
                      <div class="col-12">
                        <app-feature-list class="w-100" [featuresList]="featuresList" title="Computer" [shortTermRentalId]="shortTermRentalId" featureType="computer" describesType="{{bedroom.name}}">
                        </app-feature-list>
                      </div>
                    </div>
                  </ng-template>
                </mat-tab>
              </div>
            </div>
          </div>
        }
      </mat-tab-group>
    </mat-dialog-content>
  </div>
</div>
</div>